const shopBigPictureCta = {
  displayField: 'eyebrow',
  name: 'z-Shop Big Picture CTA',
  description: 'do not use',
  fields: [
    {
      id: 'img',
      name: 'Top Image',
      type: 'Link',
      localized: false,
      required: true,
      validations: [ { linkMimetypeGroup: [ 'image' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Asset'
    },
    {
      id: 'eyebrow',
      name: 'Eyebrow',
      type: 'Symbol',
      localized: false,
      required: true,
      validations: [ { size: { min: null, max: 256 } } ],
      disabled: false,
      omitted: false
    },
    {
      id: 'header',
      name: 'Header',
      type: 'Symbol',
      localized: false,
      required: true,
      validations: [ { size: { min: null, max: 256 } } ],
      disabled: false,
      omitted: false
    },
    {
      id: 'richText',
      name: 'RichText',
      type: 'RichText',
      localized: false,
      required: false,
      validations: [
        {
          enabledMarks: [ 'bold', 'italic' ],
          message: 'Only bold and italic marks are allowed'
        },
        { enabledNodeTypes: [], message: 'Nodes are not allowed' },
        { nodes: {} }
      ],
      disabled: false,
      omitted: false
    },
    {
      id: 'bodyText',
      name: 'Body Text',
      type: 'Text',
      localized: false,
      required: true,
      validations: [],
      disabled: true,
      omitted: true
    },
    {
      id: 'ctaText',
      name: 'Button Text',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'ctaUrl',
      name: 'Button Url',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'buttonExternalOption',
      name: 'Button External Option',
      type: 'Boolean',
      localized: false,
      required: false,
      validations: [],
      defaultValue: { 'en-US': false },
      disabled: false,
      omitted: false
    },
    {
      id: 'img2',
      name: 'Bottom Image',
      type: 'Link',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      linkType: 'Asset'
    }
  ],
  sys: {
    id: 'shopBigPictureCta',
    version: 4,
    updatedAt: '2023-08-02T22:13:10.505Z'
  }
};
export default shopBigPictureCta;